/*
React-Quill v1.0.0
https://github.com/zenoamaro/react-quill
*/
import Quill from 'quill';
import Component from './component';
import Mixin from './mixin';
import Toolbar from './toolbar';

export { Mixin, Toolbar, Quill };

export default Component;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-quill/lib/index.js
// module id = 249
// module chunks = 0